/**
 * Enable updated notifications for reseller certificates, using the in-product notification framework
 */
export const RESELLER_CERTIFICATE_NOTIFICATIONS_240611 = 'RESELLER_CERTIFICATE_NOTIFICATIONS_240611';
